module.exports = __webpack_public_path__ + "static/cg_role_178_00056920020.wav";